import React from "react";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { FloatingWhatsApp } from "./FloatingWhatsApp";

export const PublicLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-[#FDFCFB]">
    <Navbar />
    <main className="flex-1">{children}</main>
    <Footer />
    <FloatingWhatsApp />
  </div>
);
